import { Controller } from "stimulus";
import 'owl.carousel';
import 'owl.carousel2.thumbs/dist/owl.carousel2.thumbs';

export default class extends Controller {
    connect() {
        const defaultOptions = {
            loop: false,
            responsiveClass: true,
            nav: true,
            onInitialized: function(event) {
                $('.owl-dot').each(function(index) {
                    $(this).attr('aria-label', 'Отидит на елемент ' + (index + 1));
                });
            },
            onChanged: function(event) {
                $('.owl-dot').attr('aria-selected', 'false');
                $('.owl-dot.active').attr('aria-selected', 'true');
            },
            dots: true,
            navText: ["<div class='fa fa-angle-left'> <span class='sr-only'>Предишен елемент</span></div>", "<div class='fa fa-angle-right'><span class='sr-only'>Следващ елемент</span></div>"],
            items: 1
        };

        const options = this.parseOptions(this.data.get("options")) || {};
        const mergedOptions = { ...defaultOptions, ...options };


        $(this.element).owlCarousel(mergedOptions);
    }

    disconnect() {
        $(this.element).trigger("destroy.owl.carousel");
    }

    parseOptions(optionsString) {
        try {
            return optionsString ? JSON.parse(optionsString) : {};
        } catch (e) {
            console.error("Invalid JSON in data-options attribute:", e);
            return {};
        }
    }
}
